import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { BuildingOpeningDayService } from './booking/building-opening-day.service';
import { BuildingOpeningHoursService } from './booking/building-opening-hours.service';

import { BuildingService } from './booking/building.service';
import { HealthCheckService } from './health-check.service';
import { InvoiceService } from './invoice/invoice.service';
import { LegalEntityService } from './member/legal-entity.service';
import { MediaObjectService } from './media-object.service';
import { MemberService } from './member/member.service';
import { RoomBookingServiceBookingService } from './booking/room-booking-service-booking.service';
import { RoomBookingService } from './booking/room-booking.service';
import { RoomService } from './booking/room.service';
import { ServiceBookingService } from './booking/service-booking.service';
import { ServiceService } from './booking/service.service';
import { StandaloneServiceBookingService } from './booking/standalone-service-booking.service';
import { SurveyService } from './satisfaction/survey.service';
import { SurveyTopicService } from './satisfaction/survey-topic.service';
import { QuestionTypeService } from './satisfaction/question-type.service';
import { QuestionGroupService } from './satisfaction/question-group.service';
import { QuestionService } from './satisfaction/question.service';
import { QuestionGroupTopicService } from './satisfaction/question-group-topic.service';
import { CourseInstanceService, CourseService, RegistrationService } from './training';

const SERVICES = [
  BuildingService,
  MediaObjectService,
  MemberService,
  RoomBookingService,
  RoomService,
  ServiceBookingService,
  ServiceService,
  StandaloneServiceBookingService,
  LegalEntityService,
  InvoiceService,
  BuildingOpeningHoursService,
  BuildingOpeningDayService,
  SurveyService,
  SurveyTopicService,
  QuestionTypeService,
  QuestionGroupService,
  QuestionService,
  QuestionGroupTopicService,
  CourseService,
  CourseInstanceService,
  RoomBookingServiceBookingService,
  RegistrationService,
  HealthCheckService,
];

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    ...SERVICES,
  ],
})
export class DataModule {
  static forRoot(): ModuleWithProviders<DataModule> {
    return {
      ngModule: DataModule,
      providers: [
        ...SERVICES,
      ],
    } as ModuleWithProviders<DataModule>;
  }
}
